import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import Buscando from 'Component/Admin/Buscando';
import { MatriculaLista } from 'Component/Admin/Matricula';
import SemRegistros from 'Component/Admin/SemRegistros';
import Paginacao from 'Component/Paginacao';
import { useRecuperarMatriculasQuery } from 'Service';

const Matriculas = (): React.ReactElement => {
  const { id = 0 } = useParams();
  const [searchParams] = useSearchParams();

  const {
    data: { matriculas, paginacao } = {},
    isLoading,
    isFetching,
  } = useRecuperarMatriculasQuery({
    contain: ['Cursos.Categorias'],
    scope: false,
    options: { usuario_id: id },
    page: searchParams.get('pagina') || 1,
  });

  return (
    <React.Fragment>
      <Buscando exibir={isLoading} />
      <SemRegistros carregando={isLoading} registros={matriculas?.length} />
      <div className="bg-white shadow-sm rounded">
        {matriculas?.map((certificado) => (
          <MatriculaLista
            key={`${certificado.id}-${certificado.modificado}`}
            dados={certificado}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </React.Fragment>
  );
};

export default Matriculas;
